import React from "react";
import "./loading-spinner.scss";

export interface LoadingSpinnerProps {
  fullscreen?: boolean;
}

export function LoadingSpinner({
  fullscreen = false,
}: LoadingSpinnerProps): JSX.Element {
  if (fullscreen) {
    return (
      <div className="loading-spinner-fullscreen">
        <div className="loading-spinner">
          <div></div>
        </div>
      </div>
    );
  }

  return (
    <div className="loading-spinner">
      <div></div>
    </div>
  );
}
